<!-- go-chat-duplication -->
@let total = totalChatNotifications();
@if (total >= 0) {
  <button type="button" mat-icon-button [matMenuTriggerFor]="messageNotificationMenu">
    <mat-icon
      aria-hidden="false"
      [matBadgeHidden]="total === 0"
      [matBadge]="total >= 10 ? '9+' : total.toString()"
      svgIcon="mail" />
  </button>
} @else {
  <div id="spinner-container">
    <mat-spinner diameter="20" />
  </div>
}
<mat-menu #messageNotificationMenu="matMenu">
  @if (GoCoreChatService.isLoadingActiveChannel) {
    <div>
      <div class="notification-text" mat-menu-item>Loading...</div>
    </div>
  } @else {
    @if (total < 1) {
      <a disabled mat-menu-item>You have no new messages</a>
    }
    @for (chatSession of chatSessions(); track chatSession) {
      @if (chatSession.chat.unreadMessages > 0) {
        <a routerLink="/therapist/go-chat/all/{{ chatSession.id }}" mat-menu-item>
          <div class="notification-row">
            <app-avatar
              [matBadge]="chatSession.chat.unreadMessages >= 10 ? '9+' : chatSession.chat.unreadMessages.toString()"
              matBadgePosition="before"
              [patientId]="chatSession.patient.id"
              diameter="25px" />
            <div class="notification-text">
              {{ chatSession.patient.email | displayUserName: chatSession.patient.name }}
            </div>
          </div>
        </a>
      }
    }
  }
</mat-menu>
